import React from "react";
import { FilterBar } from "components/ui";
import { ContentFiltersProps } from "./types";
import styles from "./styles.module.scss";

export const ContentFilters: React.FC<ContentFiltersProps> = ({
  filters,
  activeFilters,
  onFilterChange,
  libraryType,
}) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <div className={styles.contentFilters}>
      {filters.map((filterGroup, index) => (
        <FilterBar
          key={filterGroup.id}
          filterGroupName={filterGroup.label}
          options={filterGroup.options}
          activeFilters={activeFilters[filterGroup.id] || []}
          onFilterChange={(value) => onFilterChange(filterGroup.id, value)}
          variant="vertical"
          filterGroupCount={activeFilters[filterGroup.id]?.length}
          libraryType={libraryType}
          categoryListPosition={index + 1}
          {...(index === 0
            ? { filterGroupOpen: true }
            : { filterGroupOpen: false })}
        />
      ))}
    </div>
  );
};
